<swiper-container #slider class="card-slider" init="false">
  @for (card of cards; track card.id) {
  <swiper-slide>
    <article class="card-slider__card">
      <div class="card-slider__header">
        <span class="card-slider__number">{{ card.number }}</span>
        <h4 class="card-slider__title">{{ card.title }}</h4>
      </div>

      <div class="card-slider__content">
        @if (card.inlineSvg) {
        <span class="card-slider__image card-slider__image--svg" role="img" [attr.aria-label]="card.imageAlt" [innerHTML]="card.inlineSvg"></span>
        } @else {
        <img class="card-slider__image" [src]="card.image" [alt]="card.imageAlt" loading="lazy" />
        }
        <p class="card-slider__text">{{ card.text }}</p>
      </div>
    </article>
  </swiper-slide>
  }
</swiper-container>
